import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import logo from "../assets/images/logo/meta-logo.png";

const LINKS = {
  Company: [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about-us" },
    { label: "IT Training", path: "/training" },
    { label: "Contact", path: "/contact-us" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Refund Policy", path: "/refund-policy" },
    { label: "Terms & Conditions", path: "/terms-and-conditions" },
  ],
};

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        {/* Brand */}
        <div className={styles.brand}>
          <Link to="/" className={styles.logo}>
            <img src={logo} alt="MetaWave Logo" className={styles.logoImg} />
          </Link>
          <p className={styles.tagline}>
            Empowering business through people &amp; technology.
          </p>
          <div className={styles.contact}>
            {/* <p>
              📍 2-3-54/29 & 30, Flat No.203,
              <br /> Prameela Residency Vijayapuri Colony,
              <br /> Uppal, Hyderabad, Telangana - 500039
            </p> */}
            <p>📞 +91 9000371032</p>
            <p>✉️ info@metawavesolutions.com</p>
          </div>
        </div>

        {/* Link groups */}
        {Object.entries(LINKS).map(([group, links]) => (
          <div key={group} className={styles.linkGroup}>
            <h4 className={styles.groupTitle}>{group}</h4>
            <ul>
              {links.map(({ label, path }) => (
                <li key={path}>
                  <Link to={path} className={styles.link}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Offices */}
        <div className={styles.linkGroup}>
          <h4 className={styles.groupTitle}>Offices</h4>
          <div className={styles.officeBlock}>
            <p className={styles.officeTag}>🇺🇸 United States</p>
            <p>
              Metawave Solutions LLC
              <br />
              📍800 Gathering Park Cir,
              <br />
              unit 301 Cary Nc 27519
              <br />
              📞 +1 682-200-6816
            </p>
          </div>
        </div>

        <div className={styles.linkGroup}>
          <h4 className={styles.groupTitle}>&nbsp;</h4>
          <div className={styles.officeBlock}>
            <p className={styles.officeTag}>🇮🇳 India</p>
            <p>
              Metawave Solutions LLP
              <br />
              📍 2-3-54/29 & 30,
              <br /> Flat No.203, Prameela Residency
              <br /> Vijayapuri Colony, Uppal,
              <br /> Hyderabad, Telangana - 500039
            </p>
          </div>
        </div>
      </div>

      {/* <div className={styles.bottom}>
        <p>© {new Date().getFullYear()} Metawave Solutions LLP. All Rights Reserved.</p>
        <p>
          <a href="mailto:info@metawavesolutions.com" className={styles.link}>
            info@metawavesolutions.com
          </a>
        </p>
      </div> */}
    </footer>
  );
}
